module.exports = "<div>\n  <new-discount-form-select-event-parent\n    (updateDiscountEvent)=\"updateDiscountEvent.emit($event)\"\n\n    [newDiscountFormState]=\"newDiscountFormState$\"\n  >\n    >\n  </new-discount-form-select-event-parent>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/discounts/new-discount-form-select-event/new-discount-form-select-event.component.html
// module id = ./src/app/admin/discounts/new-discount-form-select-event/new-discount-form-select-event.component.html
// module chunks = main